import { useEffect, useState } from "react";
import { collection, doc, onSnapshot, query, updateDoc, where, writeBatch } from "firebase/firestore";
import { db } from "../firebaseConfig";

const tiempo = (n) => (n.creada && n.creada.seconds ? n.creada.seconds : 0);

// Notificaciones sin leer del usuario, en tiempo real (la más reciente primero)
export const useNotificaciones = (uid) => {
  const [pendientes, setPendientes] = useState([]);

  useEffect(() => {
    if (!uid) {
      setPendientes([]);
      return undefined;
    }
    const q = query(collection(db, "notificaciones"), where("uid", "==", uid), where("leida", "==", false));
    return onSnapshot(
      q,
      (snap) => {
        const lista = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        lista.sort((a, b) => tiempo(b) - tiempo(a));
        setPendientes(lista);
      },
      (error) => console.error("Error al escuchar notificaciones:", error)
    );
  }, [uid]);

  const marcarLeida = (id) => updateDoc(doc(db, "notificaciones", id), { leida: true }).catch(console.error);

  const marcarTodas = async () => {
    const lote = writeBatch(db);
    pendientes.slice(0, 400).forEach((n) => lote.update(doc(db, "notificaciones", n.id), { leida: true }));
    await lote.commit().catch(console.error);
  };

  return { pendientes, marcarLeida, marcarTodas };
};
